module.exports = __webpack_public_path__ + "static/media/iPhone14-7.6452ef12.png";